<script setup lang="ts">
import { onLaunch, onHide } from '@dcloudio/uni-app'
import { useTabbarStore, useUserStore } from './store'
import { checkWithRedirectLogin, loginRoute } from './interceptors/route'

const tabbarStore = useTabbarStore()

onLaunch((options) => {
  if (checkWithRedirectLogin(options.path)) {
    uni.reLaunch({
      url: loginRoute,
      // query: {
      // redirect: options.path,
      // },
    })
  } else {
    if (userStore.isLogged) {
      userStore.loadUserInfo()
    }
  }
  tabbarStore.tabbarList
    .filter((_, index) => index)
    .forEach((item) => {
      uni.preloadPage({ url: item.path })
    })
})

onPageNotFound(() => {
  console.log(1)
  uni.reLaunch({
    url: '/',
  })
})

onHide(() => {
  console.log('App Hide')
})

const userStore = useUserStore()
</script>

<style lang="scss">
/* 覆盖 uniapp 自带rpx效果 */
html {
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
/* stylelint-disable-next-line selector-type-no-unknown */
#app {
  max-width: 500px; /* apply-without-convert */
  margin: 0 auto;
  box-shadow: inherit;
}

@media screen and (min-width: 500px) {
  #app {
    max-width: 375px;
  }
}
/* stylelint-disable selector-type-no-unknown */
button::after {
  border: none;
}

swiper,
scroll-view {
  flex: 1;
  height: 100%;
  overflow: hidden;
}

image {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}

// 单行省略，优先使用 unocss: text-ellipsis
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// 两行省略
.ellipsis-2 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

// 三行省略
.ellipsis-3 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

image {
  display: block;
}
view {
  box-sizing: border-box;
}

uni-modal {
  .uni-modal {
    @apply max-w-345px rounded-16px;
  }

  .uni-modal__hd {
    @apply p-0;
  }

  .uni-modal__title {
    @apply p-15px text-left text-16px font-600;
  }

  .uni-modal__bd {
    @apply px-15px pt-0 text-left text-14px font-medium text-#666;
  }

  .uni-modal__btn {
    @apply px-15px py-6px flex-none rounded-full shadow-none text-14px;

    &::after {
      content: none;
    }

    &.uni-modal__btn_primary {
      @apply ml-8px bg-gray-200 !text-black;
    }
  }

  .uni-modal__ft {
    @apply justify-end px-15px pb-10px leading-normal;

    &::after {
      content: none;
    }
  }
}

.page-bg {
  padding-bottom: calc(4px + env(safe-area-inset-bottom));
  background-image: url('@/static/images/bg-1.jpg');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: top left;
  background-size: 100% 100%;
  &.tabbar {
    padding-bottom: calc(70px + env(safe-area-inset-bottom));
  }
}

.page-bg-2 {
  padding-bottom: calc(4px + env(safe-area-inset-bottom));
  background-image: url('@/static/images/bg-2.jpg');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: top left;
  background-size: 100% 100%;
  &.tabbar {
    padding-bottom: calc(70px + env(safe-area-inset-bottom));
  }
}

.bottom-popup-bg {
  background:
    url('@/static/images/bottom-popup-bg.png') top center / 750rpx,
    linear-gradient(
        to right,
        #ffffff 40%,
        rgba(255, 255, 255, 0) 41%,
        rgba(255, 255, 255, 0) 60%,
        #ffffff 61%
      )
      top left / 100% 150rpx,
    linear-gradient(to right, #fff, #fff) top 150rpx left / 100% 100%;
  background-repeat: no-repeat;
}

.uni-tabbar-border {
  display: none;
}
.rich-text {
  img {
    display: block;
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }
}
.uni-page-refresh__path {
  stroke: #1183e6;
}
.uni-page-refresh__icon {
  fill: #1183e6;
}
</style>
